export default __webpack_public_path__ + "b039eb28e033d93f5f4eca9e63240369.png";